<template>
  <div class="filter-item">
    <v-tooltip
      v-if="configs.hint && configs.type != 'checkbox'"
      bottom>
      <template v-slot:activator="{ on }">
        <v-icon v-on="on">help_outline</v-icon>
      </template>
      <span>{{ configs.hint }}</span>
    </v-tooltip>

    <v-text-field
      v-if="configs.type == 'text'"
      :label="configs.text"
      outlined
      :clearable="configs.clearable"
      v-model="model"
    />

    <div v-if="configs.type == 'checkbox'"
         class="v-input theme--light mb-4"
    >
      <v-btn-toggle
        mandatory
        v-model="model">
        <v-btn>
          <v-icon>filter_alt_off</v-icon>
        </v-btn>
        <v-btn>
          <v-icon>done</v-icon>
        </v-btn>
        <v-btn>
          <v-icon>block</v-icon>
        </v-btn>
      </v-btn-toggle>
      <div class="ml-3">{{ configs.text }}</div>
      <v-tooltip
        v-if="configs.hint"
        bottom>
        <template v-slot:activator="{ on }">
          <v-icon v-on="on">help_outline</v-icon>
        </template>
        <span>{{ configs.hint }}</span>
      </v-tooltip>
    </div>

    <v-select
      v-if="configs.type == 'select'"
      :items="items"
      item-text="translatedName"
      item-value="id"
      :menu-props="{bottom: true, offsetY: true}"
      v-model="model"
      outlined
      :clearable="configs.clearable"
      :label="configs.text"
    />
    <v-autocomplete
      v-if="configs.type == 'multiselect'"
      :clearable="configs.clearable"
      outlined
      hide-selected
      multiple
      small-chips
      deletable-chips
      :menu-props="{bottom: true, offsetY: true}"
      :items="items"
      item-text="translatedName"
      item-value="id"
      v-model="model"
      :label="configs.text"
    />
    <v-autocomplete
        v-if="configs.type == 'searchable-select'"
        :clearable="configs.clearable"
        outlined
        hide-selected
        :menu-props="{bottom: true, offsetY: true}"
        :items="items"
        item-text="translatedName"
        item-value="id"
        v-model="model"
        :label="configs.text"
    />
    <DateField
      v-if="configs.type == 'date'"
      @update="(v) => (model = v)"
      :isClearable="configs.clearable"
      :initDate="model"
      :label="configs.text"
    />
  </div>
</template>
<script>
import DateField from '@/modules/core/components/DateField';
import InfoService from '@/modules/core/services/info-service';
import EnumUtils from '@/modules/core/services/enum-utils';

export default {
  name: 'FilterItem',
  components: {
    DateField
  },
  props: {
    modelItem: null,
    configs: Object,
    filterName: String
  },
  data() {
    return {
      model: null,
      items: null,
      show: false,
      selectItems: []
    }
  },
  created() {
    this.model = this.modelItem;
    if (this.configs.preselect !== null && this.modelItem === null) {
      this.model = this.configs.preselect;
    }

    if (this.configs.type === 'select' || this.configs.type === 'multiselect' || this.configs.type === 'searchable-select') {
      if (this.configs.loadedOptions) {
        this.items = this.configs.loadedOptions;
      } else if (this.configs.enum) {
        this.loadEnum(this.configs);
      } else {
        this.loadOptions(this.configs);
      }
      this.show = true;
    }

    if (this.configs.invokeFns !== null) {
      if (typeof this.configs.invokeFns.setInvokeVariable === 'function') {
        this.configs.invokeFns.setInvokeVariable(this.invokeUpdateOfComponent);
      }
    }
  },
  watch: {
    model() {
      this.invokeUpdateOfComponent();
      this.$emit('updateValue', this.model);
    }
  },
  methods: {
    resetValue() {
      this.model = null;
    },
    loadEnum(filterData) {
      let filterItemName = filterData.options.length > 0 ? filterData.options : filterData.value;
      if (this.selectItems[filterItemName]) {
        filterData.items = this.selectItems[filterData.options];
        return;
      }

      let loadedModule = this.$store.state.manager.module;

      EnumUtils.loadEnum(`${filterItemName}`, `${loadedModule}/${this.filterName}`, filterItemName,
        (response) => {
          this.items = response;
          if (filterData.translate) {
            this.items = this.forceTranslate(this.items, filterData);
          }
        }
      );
    },

    loadOptions(filterData) {
      if (filterData.url !== null) {
        this.loadOptionByUrl(filterData)
      } else {
        this.loadOptionByDefaultUrl(filterData);
      }
    },

    loadOptionByDefaultUrl(filterData) {
      let filterItemName = filterData.options.length > 0 ? filterData.options : filterData.value;
      InfoService.readOptions(`${this.filterName}/${filterItemName}`,
        (response) => {
          this.items = response;
          if (filterData.translate) {
            this.items = this.forceTranslate(this.items, filterData);
          }
        }
      );
    },

    loadOptionByUrl(filterData) {

      InfoService.readOptionsByUrl(filterData.url,
        (response) => {
          this.items = response;

          if (filterData.translate) {
            this.items = this.forceTranslate(this.items, filterData);
          }
        }
      );
    },

    /**
     * Force translate the options which is not an Enum but value from DB
     * @param items
     */
    forceTranslate(items, filterData) {

      if (filterData.translateFn !== null) {
        return filterData.translateFn(items);
      }

      let optionsName = filterData.options.length > 0 ? filterData.options : filterData.value;
      let moduleName = this.$store.state.manager.module;

      for (let i = 0; i < items.length; i++) {
        items[i].translatedName
          = this.$t(`${moduleName}/${this.filterName}:options.${optionsName}.${items[i].translatedName}`);
      }

      return items;
    },

    invokeUpdateOfComponent() {
      if (this.configs.invokeFns !== null) {
        let invokeFns = this.configs.invokeFns;

        if (typeof invokeFns.updateModel === 'function') {
          this.model = invokeFns.updateModel(this.model);
        }

        if (typeof  invokeFns.updateItems  === 'function') {
          this.items = invokeFns.updateItems(this.items);
        }
      }
    }

  }
}
</script>